var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A4B8D1",
    fillRule: "evenodd",
    d: "M16.522 18.27a1 1 0 1 1-1.338 1.487l-7.866-7.08a1 1 0 0 1 0-1.487l7.866-7.08a1 1 0 1 1 1.338 1.487l-7.04 6.336z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeft;